import React from "react";
import { Link } from "react-router-dom";
import { ChefHat, Bath, Sofa, Home, PaintBucket, Wrench, ArrowRight } from "lucide-react";
import Reveal from "../shared/Reveal";

const SERVICES = [
  {
    icon: ChefHat,
    title: "Kitchen Remodeling",
    desc: "Custom cabinetry, countertops, and modern layouts for Baltimore families.",
    slug: "kitchen",
  },
  {
    icon: Bath,
    title: "Bathroom Remodeling",
    desc: "Spa-quality bathrooms from tub-to-shower conversions to full gut renovations.",
    slug: "bathroom",
  },
  {
    icon: Sofa,
    title: "Basement Finishing",
    desc: "Transform unused space into living rooms, home offices, and guest suites.",
    slug: "basement",
  },
  {
    icon: Home,
    title: "Whole-House Renovation",
    desc: "Full-home transformations with single-point accountability from demo to finish.",
    slug: "whole-house",
  },
  {
    icon: PaintBucket,
    title: "Exterior Remodeling",
    desc: "Siding, roofing, windows, and outdoor living that boosts curb appeal.",
    slug: "exterior",
  },
  {
    icon: Wrench,
    title: "Other Services",
    desc: "Custom additions, aging-in-place modifications, and specialty projects.",
    slug: "other",
  },
];

export default function HomeServicesGrid() {
  return (
    <section className="py-20 lg:py-28 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <p className="font-body text-accent text-sm font-semibold uppercase tracking-[0.18em] mb-3">What We Do</p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Full-Service Remodeling
          </h2>
          <p className="font-body text-lg text-muted-foreground leading-relaxed">
            One contractor. Every trade. No hand-offs. We handle your project start-to-finish under a single point of accountability.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((service, i) => (
            <Reveal
              key={service.slug}
              delay={i * 70}
            >
              <Link
                to={`/services/${service.slug}`}
                className="group block bg-card rounded-xl p-7 border border-border hover:border-accent/40 hover:shadow-lg transition-all duration-300 h-full"
              >
                <div className="w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center mb-5 group-hover:bg-accent group-hover:text-white transition-all duration-300">
                  <service.icon className="w-6 h-6 text-accent group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="font-heading text-xl font-bold text-foreground mb-2 group-hover:text-accent transition-colors">
                  {service.title}
                </h3>
                <p className="font-body text-sm text-muted-foreground leading-relaxed mb-4">
                  {service.desc}
                </p>
                <span className="inline-flex items-center gap-1.5 font-body text-sm font-semibold text-accent">
                  Learn More <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}